import { render, staticRenderFns } from "./posterManageDetail.vue?vue&type=template&id=03284aec&scoped=true&"
import script from "./posterManageDetail.vue?vue&type=script&lang=js&"
export * from "./posterManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./posterManageDetail.vue?vue&type=style&index=0&id=03284aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03284aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03284aec')) {
      api.createRecord('03284aec', component.options)
    } else {
      api.reload('03284aec', component.options)
    }
    module.hot.accept("./posterManageDetail.vue?vue&type=template&id=03284aec&scoped=true&", function () {
      api.rerender('03284aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/posterManage/posterManageDetail.vue"
export default component.exports